import { useMemo } from 'react';
import { useTranslate } from '@refinedev/core';

import { DEFAULT_TRANSLATIONS, TRANSLATION_KEYS } from '../constants';
import type { UploadTranslations } from '../types';

export function useUploadTranslations(): UploadTranslations {
    const t = useTranslate();

    return useMemo(
        () => ({
            uploadClick: t(TRANSLATION_KEYS.uploadClick, DEFAULT_TRANSLATIONS.uploadClick),
            uploadDrag: t(TRANSLATION_KEYS.uploadDrag, DEFAULT_TRANSLATIONS.uploadDrag),
            supportedFormats: t(TRANSLATION_KEYS.supportedFormats, DEFAULT_TRANSLATIONS.supportedFormats),
            uploadFailedTitle: t(TRANSLATION_KEYS.uploadFailedTitle, DEFAULT_TRANSLATIONS.uploadFailedTitle),
            uploadFailedCommon: t(TRANSLATION_KEYS.uploadFailedCommon, DEFAULT_TRANSLATIONS.uploadFailedCommon),
            zipOnly: t(TRANSLATION_KEYS.zipOnly, DEFAULT_TRANSLATIONS.zipOnly),
            uploadSuccess: t(TRANSLATION_KEYS.uploadSuccess, DEFAULT_TRANSLATIONS.uploadSuccess),
            tryAgain: t(TRANSLATION_KEYS.tryAgain, DEFAULT_TRANSLATIONS.tryAgain),
            noFiles: t(TRANSLATION_KEYS.noFiles, DEFAULT_TRANSLATIONS.noFiles),
            removeFile: t(TRANSLATION_KEYS.removeFile, DEFAULT_TRANSLATIONS.removeFile),
            selectFile: t(TRANSLATION_KEYS.selectFile, DEFAULT_TRANSLATIONS.selectFile),
            upload: t(TRANSLATION_KEYS.upload, DEFAULT_TRANSLATIONS.upload),
        }),
        [t]
    );
}
